import React from 'react';
import ReactDOM from 'react-dom/client';
import PDMSimulator from './pdm-simulator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PDMSimulator />
  </React.StrictMode>
);
